import axios from "axios";

/**
 * Generic API call for lookup dropdowns
 * Works for both single and multi select
 */
export const fetchLookupItems = async ({
    tableName,
    idColumn,
    nameColumn,
    searchText = "",
    type = "single"
}) => {
    try {
        const response = await axios.get(
            `https://localhost:7248/api/lookup-items/${type}`,
            {
                params: {
                    tableName,
                    idColumn,
                    nameColumn,
                    search: searchText
                }
            }
        );

        return response?.data ?? [];
    } catch (error) {
        console.error("fetchLookupItems error:", error);
        return [];
    }
};

